export const apiError = (error) => {
  let errorMessage = "An unknown error occurred";

  if (error.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    const statusCode = error.response.status;
    const statusText = error.response.statusText;
    const responseData = error.response.data;
    const responseDataMessage = responseData?.message;
    errorMessage = `Error ${statusCode} (${statusText}): ${responseData} ${responseDataMessage ? ` - ${responseDataMessage}` : ""}`;
  } else if (error.request) {
    // The request was made but no response was received
    errorMessage =
      "No response received from the platform backend server." +
      " Please check your network connection. If the error persists contact our support team.";
  } else {
    // Something happened in setting up the request that triggered an Error
    errorMessage = error.message;
  }

  alert("Error :\n" + errorMessage);
};
